<ng-template #template>
  <div id="confirm-modal" class="modal-body text-center">
    <p id="confirm-title-text" style="font-size: 16px;"><strong>{{title}}</strong></p>
    <div id="confirm-content-text" class="message" [innerHtml]="message"></div>
    <button id="confirm-cancle-button" type="button" class="btn btn-secondary mt-1 text-uppercase" (click)="onClose()">CANCEL</button>
    <button id="confirm-button" type="button" class="btn btn-primary ml-2 mt-1 text-uppercase" (click)="onSubmit()">{{btnConfirm}}</button>
  </div>
</ng-template>